import { Typography } from 'antd';
import * as React from 'react';
import styled from 'styled-components';
const { Text } = Typography;

const LabeledItemWrapper = styled.div`
  line-height: 1;
`;

const FormLabelStyled = styled.div`
  line-height: 1.5;
  font-size: 12px;
  font-weight: 300;
  color: ${props => props.theme.colorTextSecondary};

  // Text ellipsis overflow
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export interface LabeledItemProps extends React.HTMLAttributes<HTMLDivElement> {
  label: string;
}

export function LabeledItem(props: LabeledItemProps) {
  const { label, children, ...rest } = props;
  return (
    <LabeledItemWrapper {...rest}>
      <FormLabelStyled>{label}</FormLabelStyled>
      {children}
    </LabeledItemWrapper>
  );
}
